<template>
    <el-row>
        <el-row>
            <el-table :data="page.records">
                <el-table-column prop="code" label="编号">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">编号</span><br>
                        <el-input size="mini" v-model="pageSearch.search.code">
                        </el-input>
                    </template>
                    <template slot-scope="scope">
                        <el-button @click="toDetailShow(scope.row)" type="text" size="mini">
                            {{scope.row.code}}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="数据中心">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">数据中心</span><br>
                        <dictionary-select v-model="pageSearch.search.roomId"
                                           :factory-name="'room'" :params="{type: 'AUTH_SITE'}"
                                           :clearable="true" :filterable="true" size="mini">
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <dictionary-text :factory-name="'room'" :params="{type: 'AUTH_SITE'}" :value="scope.row.roomId">
                        </dictionary-text>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="类型">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">类型</span><br>
                        <dictionary-select v-model="pageSearch.search.type"
                                           :factory-name="'domain'" :params="'ASSETTYPE'"
                                           :clearable="true" :filterable="true" size="mini">
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <dictionary-text :factory-name="'domain'" :params="'ASSETTYPE'" :value="scope.row.type">
                        </dictionary-text>
                    </template>
                </el-table-column>
                <!--<el-table-column label="供应商">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">供应商</span><br>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.vendorId}}
                    </template>
                </el-table-column>-->
                <el-table-column prop="description" label="描述">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">描述</span><br>
                        <el-input size="mini" class="width70"
                                  v-model="pageSearch.search.description">
                        </el-input>
                    </template>
                </el-table-column>

                <el-table-column label="位置">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">位置</span><br>
                        <location-select ref="locationSelect" v-model="pageSearch.search.locationId" :room-id="pageSearch.search.roomId"
                                         :clearable="true" :filterable="true"
                                         :size="'mini'" :clazz="{'width100': true}">
                        </location-select>
                    </template>
                    <template slot-scope="scope">
                        {{$refs.locationSelect.getLabelByValue(scope.row.locationId, $refs.locationSelect.locations)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">操作</span><br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        <div>
                            <el-button type="danger" plain size="minimum" @click="remove(scope.row)">
                                移除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination
                    @current-change="setPageSearchCurrent"
                    @size-change="setPageSearchSize"
                    :current-page="pageSearch.current"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageSearch.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </el-row>
    </el-row>
</template>

<script>
    import DcimServer from "@/api/dcim";
    import {merge} from "@/util";
    import DictionarySelect from "@/components/common/DictionarySelect";
    import DictionaryText from "@/components/common/DictionaryText";
    import LocationSelect from "@/components/location/location-select";
    import {RESOURCE_IP_PORT} from "@/api";

    export default {
        name: "equipment-group-equipment-page",
        props: {
            groupId: {},
        },
        components: {
            LocationSelect,
            DictionarySelect, DictionaryText,
        },
        data() {
            return {
                pageSearch: {
                    current: 0,
                    size: 10,
                    search: {
                        code: null,
                        type: null,
                        description: null,
                        locationId: null,
                    },
                },
                page: {
                    total: 0,
                    records: [],
                },
            };
        },
        watch: {
            'pageSearch.current': {
                deep: false,
                immediate: false,
                handler() {
                    this.queryByPage();
                },
            },
            'pageSearch.size': {
                deep: false,
                immediate: false,
                handler() {
                    this.reQueryByPage();
                },
            },
            'pageSearch.search': {
                deep: true,
                immediate: false,
                handler(search) {
                    this.reQueryByPage();
                    if (search != null) {
                        //
                    }
                }
            },
        },
        methods: {
            setPageSearchCurrent(current) {
                this.pageSearch.current = current;
            },
            setPageSearchSize(size) {
                this.pageSearch.size = size;
            },
            setPage(page) {
                this.page = page;
            },
            async doQueryByPage(pageSearch) {
                return DcimServer.equipment.page(pageSearch);
            },
            reQueryByPage() {
                if (this.pageSearch.current === 1) {
                    this.queryByPage();
                } else {
                    this.setPageSearchCurrent(1);
                }
            },
            async queryByPage() {
                let page = {total: 0, records: [],};
                let groupId = this.groupId;
                let pageSearch = JSON.parse(JSON.stringify(this.pageSearch));
                if (groupId != null && groupId !== '') {
                    let groupItems = await DcimServer.equipmentGroupItem.list({eq_groupId: groupId});
                    let itemIds = groupItems.map(e => e.itemId);
                    if (itemIds.length > 0) {
                        let search = {in_id: itemIds};
                        pageSearch.search = merge(true, pageSearch.search, search);
                        page = await this.doQueryByPage(pageSearch);
                    }
                }
                if (page.records.length === 0 && pageSearch.current > 1) {
                    this.setPageSearchCurrent(pageSearch.current - 1);
                } else {
                    this.setPage(page);
                }
                return Promise.resolve(page);
            },
            query() {
                this.queryByPage();
            },
            reQuery() {
                this.reQueryByPage();
            },
            toDetailShow(row) {
                window.open(`${process.env.VUE_APP_WEB_API}/dcim/equipment?id=${row.id}`);
            },
            async remove(row) {
                let confirmed = false;
                confirmed = await this.$confirm('确定移除吗？', '移除提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });
                try {
                    if (confirmed) {
                        await DcimServer.equipmentGroupItem.removeByGroupIdAndItemId(this.groupId, row.id);
                        this.queryByPage();
                    }
                } catch (message) {
                    this.$message.error(message);
                }
            },
        },
        mounted() {
            this.query();
        },
        beforeDestroy() {

        },
    }
</script>

<style scoped>

</style>
